// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container .no-bar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.home-container .no-bar::-webkit-scrollbar {
  display: none;
}

.back-btn {
  background-color: #4d90fd;
  border: 1px solid #cee0f5;
  color: #fefefe;
  padding: 5px 10px;
  font-weight: 100;
}

.candidate-portfolio-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
  padding: 10px 10px;
  gap: 4px;
  cursor: pointer;
  margin-bottom: 8px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/HomeContent/HomeContent.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;EACA,qBAAA;AAAJ;AAGE;EACE,aAAA;AADJ;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAFF","sourcesContent":[".home-container {\n  .no-bar {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n\n  .no-bar::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.back-btn {\n  background-color: #4d90fd;\n  border: 1px solid #cee0f5;\n  color: #fefefe;\n  padding: 5px 10px;\n  font-weight: 100;\n}\n\n.candidate-portfolio-banner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #000;\n  color: #fff;\n  padding: 10px 10px;\n  gap: 4px;\n  cursor: pointer;\n  margin-bottom: 8px;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
